export default __webpack_public_path__ + "static/media/galet-thecamp-white.85f2f480.svg";